import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Flexer } from '@ontruck/orc';
import { NavBarStyled, NavLinkStyled } from './styled';
import { injectIntl } from 'react-intl';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const JobsSelector = ({ intl }) => {
  const unassignedSection = useSelector((state) =>
    getSpecificClientConfig(state, constants.UNASSIGNED_SECTION)
  );
  const t = intl.messages.modules.JobSelector;
  return (
    <Flexer.Child mRight="S">
      <NavBarStyled data-e2e="filters__jobSection">
        {unassignedSection && (
          <NavLinkStyled to="/jobs/unassigned" data-e2e="filters__jobSection_unassigned">
            {t.unassigned}
          </NavLinkStyled>
        )}
        <NavLinkStyled to="/jobs/assigned" data-e2e="filters__jobSection_assigned">
          {t.assigned}
        </NavLinkStyled>
        <NavLinkStyled to="/jobs/finished" data-e2e="filters__jobSection_finished">
          {t.finished}
        </NavLinkStyled>
      </NavBarStyled>
    </Flexer.Child>
  );
};

export default connect(null)(injectIntl(JobsSelector));
